import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { useHistory, useLocation } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../common/hooks'
import { cartActions } from '../../store/slices/cart'
import { scheduledDeliveryActions } from '../../store/slices/scheduleDelivery'
import { sessionActions } from '../../store/slices/session'
import { shippingInfosActions } from '../../store/slices/ShippingInfos'
import {
  ButtonSpinner,
  StyledActions,
  StyledContent,
  StyledDescription,
  StyledErrorMessage,
  StyledHeader,
  StyledModal,
  StyledPrimaryButton,
  StyledSecondaryButton,
  StyledTitle,
  StyledWarningIconWrapper,
  StyledWarningText,
  StyledWarningWrapper,
  StyledWrapper,
} from './styles/MigrationAbasteceShopModal.style'
import { URLS_ABASTECE_SHOP } from '../../common/constants'
import { redirectToAbasteceShopWithSso } from '../../common/abasteceShopSso'
import { useState } from 'react'

const notOpenModalRoutes = [
  '/invoices',
  '/profile',
  '/profile/contacts',
  '/pedidos-em-aberto',
  '/sales-flyer',
  '/redirect-abastece-shop',
  '/purchase',
  '/delivery',
]

export const MigrationAbasteceShopModal = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const location = useLocation()
  const { merchantCode, clubberEmail, hasMigratedToAbasteceshop } = useAppSelector(
    (state) => state.session
  )
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const isOpen =
    Boolean(merchantCode) &&
    Boolean(hasMigratedToAbasteceshop) &&
    !notOpenModalRoutes.includes(location.pathname) &&
    !location.pathname.startsWith('/delivery-summary/')
  const hasClubberEmail = Boolean(clubberEmail)

  const primaryButtonLabel = hasClubberEmail ? 'Ir para o Smart Force' : 'Ir para a AbasteceShop'
  const title = hasClubberEmail
    ? 'Este cliente agora compra na nova plataforma'
    : 'Continue sua compra na nova loja'

  const description = hasClubberEmail ? (
    <>
      Este cliente já foi migrado para o AbasteceShop.
      <br />
      Novos pedidos devem ser realizados na nova plataforma.
      <br />
      Você também pode tirar pedidos pelo aplicativo <strong>Smart Force</strong>.
    </>
  ) : (
    <>
      Você já começou a comprar pelo <strong>AbasteceShop</strong>.
      <br />
      Para novos pedidos, utilize a nova plataforma.
    </>
  )

  const handlePrimaryClick = async () => {
    setIsLoading(true)
    if (hasClubberEmail) {
      window.open(URLS_ABASTECE_SHOP.APP_STORE_SMART_FORCE, '_blank', 'noopener,noreferrer')
      return
    }

    const success = await redirectToAbasteceShopWithSso(merchantCode)
    if (!success) {
      setErrorMessage('Não foi possível redirecionar para o AbasteceShop')
    }

    setIsLoading(false)
  }

  const handleInvoicesClick = () => {
    history.push('/invoices')
  }

  const handleSwitchCustomerClick = () => {
    dispatch(sessionActions.clearMerchantData())
    dispatch(cartActions.cleanUp())
    dispatch(shippingInfosActions.reset())
    dispatch(scheduledDeliveryActions.clearScheduledDelivery())
    dispatch(sessionActions.showModal(false))
  }

  return (
    <StyledModal open={isOpen} disableEscapeKeyDown>
      <StyledWrapper>
        <StyledHeader>
          <StyledTitle>{title}</StyledTitle>
        </StyledHeader>
        <StyledContent>
          <StyledDescription>{description}</StyledDescription>
          {!hasClubberEmail && (
            <StyledWarningWrapper>
              <StyledWarningIconWrapper>
                <WarningAmberOutlinedIcon />
              </StyledWarningIconWrapper>
              <StyledWarningText>
                Você ainda pode consultar as entregas anteriores na loja antiga da Clubbi.
              </StyledWarningText>
            </StyledWarningWrapper>
          )}
          {errorMessage && <StyledErrorMessage>{errorMessage}</StyledErrorMessage>}
          <StyledActions>
            <StyledPrimaryButton onClick={handlePrimaryClick}>
              {isLoading ? <ButtonSpinner /> : primaryButtonLabel}
            </StyledPrimaryButton>
            <StyledSecondaryButton onClick={handleInvoicesClick}>
              Ver entregas anteriores
            </StyledSecondaryButton>
            <StyledSecondaryButton onClick={handleSwitchCustomerClick}>
              Entrar com outro código
            </StyledSecondaryButton>
          </StyledActions>
        </StyledContent>
      </StyledWrapper>
    </StyledModal>
  )
}
